const {
  UNSUBSCRIBE,
  DELETED,
  APPROVED,
  ADMIN,
  ADMIN_SECONDARY,
  SELLER,
} = require('../constants/user');

export const getHtmlIdBlockUserModal = (action = '', status = '') => {
  switch (action) {
    case UNSUBSCRIBE:
      return {
        confirm: 'confirm-block-collaborator',
        cancel: 'cancel-block-collaborator',
      };
    case DELETED:
      return status === APPROVED
        ? {
            confirm: 'confirm-delete-collaborator',
            cancel: 'cancel-delete-collaborator',
          }
        : {
            confirm: 'confirm-peding-collaborator-delete',
            cancel: 'cancel-pending-collaborator-delete',
          };
    default:
      return {
        confirm: '',
        cancel: '',
      };
  }
};

export const getHtmlIdUserCard = (role = '') => {
  switch (role) {
    case ADMIN:
      return 'select-role-superadmin';
    case ADMIN_SECONDARY:
      return 'select-role-admin';
    case SELLER:
      return 'select-role-seller';
    default:
      return '';
  }
};
